import React from 'react'
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './TakeImage.css';

const TakeImage = () => {
  return (
    <div className="file-inputs">
      <div className='innerB'></div>
      <button>
        <i>
          <FontAwesomeIcon icon={faCamera} />
        </i>
        <span className='btn-span'>Take Photo</span>
      </button>
    </div>
  )
}

export default TakeImage